var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"grid is-ultrawide-5 is-widescreen-6 is-desktop-7 is-tablet-8 is-center"},[_c('LoginForm',{on:{"success":_vm.onSuccess}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }